import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { quantidadeBimestre } from '../Planejamento/api-planejamento';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import CircularProgress from '@mui/material/CircularProgress';

const useStyles = makeStyles({
    paper: {
        padding: '20px',
        backgroundColor: '#f5f5f5',
    },
    title: {
        paddingTop: '20px;',
        margin: '20px'
    },
    adicionarDisciplina: {
        paddingBottom: '10px',
    },
    formControl: {
        marginBottom: '10px'
    }, 
    loading :{
        marginRight: '20px',
        marginLeft: '20px'
    }
});

export default function PlanejamentoConsultaQuant() {
    const classes = useStyles();
    const [listaPlanQuant, setListaPlanQuant] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        quantidadeBimestre().then((data) => {
            if (data) {
                setListaPlanQuant(data);
                setLoading(false);
            }
        })

    }, []);



    return (
        <div>
            <CssBaseline />
            <Container className={classes.paper} component={Paper}>
                <Typography className={classes.title} variant="h5">
                    Planejamento Consulta Quantidade
                </Typography>
                {loading ?
                    <>
                        <CircularProgress className={classes.loading} color="primary" />
                        Carregando... 
                    </>
                    :
                    <Table className={classes.table} size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Turma</TableCell>
                                <TableCell>Disciplina</TableCell>
                                <TableCell>Professor</TableCell>
                                <TableCell>1º Bimestre</TableCell>
                                <TableCell>2º Bimestre</TableCell>
                                <TableCell>3º Bimestre</TableCell>
                                <TableCell>4º Bimestre</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {listaPlanQuant.length > 0 ? listaPlanQuant.map((planQuant, index) => (
                                <TableRow key={index}>
                                    <TableCell>{planQuant.tdp.turma.descricao}</TableCell>
                                    <TableCell>{planQuant.tdp.disciplina.descricao}</TableCell>
                                    <TableCell>{planQuant.tdp.usuario ? planQuant.tdp.usuario.nome : ''}</TableCell>
                                    <TableCell style={{ backgroundColor: planQuant.quant1Bim === 0 ? '#ef9a9a' : '' }}>{planQuant.quant1Bim}</TableCell>
                                    <TableCell style={{ backgroundColor: planQuant.quant2Bim === 0 ? '#ef9a9a' : '' }}>
                                        {planQuant.quant2Bim}
                                    </TableCell>
                                    <TableCell style={{ backgroundColor: planQuant.quant3Bim === 0 ? '#ef9a9a' : '' }}>{planQuant.quant3Bim}</TableCell>
                                    <TableCell style={{ backgroundColor: planQuant.quant4Bim === 0 ? '#ef9a9a' : '' }}>{planQuant.quant4Bim}</TableCell>
                                </TableRow>
                            )) : ''}
                        </TableBody>
                    </Table>
                }



            </Container>

        </div>
    );
}